<!-- Form -->
<form (ngSubmit)="handleSubmit($event)">
  <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)" selectedIndex="0" xpoAlternateTabs>
    <!-- Simple Search Tab -->

    <mat-tab label="basic" >
    <!--  <div > -->
        <simple-tab
          [criteria]="criteria"
          [isWebMode]="isWebMode"
          [isInboundQuery]="isInboundQuery()"
          (onRemoveReference)="removeReferenceNumber($event)"
          (onAddReference)="addReferenceNumber($event)"
          (onOpenHelp)="openHelp($event)"
          (onSetDocumentType)="setDocumentType($event)">
        </simple-tab>
      <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px; padding-bottom: 20px; padding-left: 20px; padding-right: 30px;">
        <!-- Export Button -->
        <button mat-raised-button color="primary" class="xpo-primary-action" type="submit" (click)="criteria.simple.exportable=true; search('simple')" aria-label="export" title="Export">
          <mat-icon>save</mat-icon>
          Export
        </button>

        <!-- Clear and Search Buttons on the right -->
        <div>
          <!-- Clear Button -->
          <button mat-button color="primary" type="button" (click)="clear()" aria-label="clear search criteria" title="Clear search criteria">
            <mat-icon>clear</mat-icon>
            Clear
          </button>

          <!-- Search Button -->
          <button mat-raised-button color="primary" class="xpo-primary-action" type="submit" (click)="criteria.simple.exportable=false; search('simple')" *ngIf="!criteria.simple.showExportOptions" aria-label="search" title="Search">
            <mat-icon>search</mat-icon>
            Search
          </button>
        </div>
      </div>
    <!--  </div> -->
    </mat-tab>

    <!-- Advanced Search Tab -->
    <mat-tab label="advanced">
      <div class="advanced-tab-content">
      <div class="flex-container" fxLayout="row" fxLayoutGap="10px" style="margin-top: 27px;">
        <!-- Direction Select -->
        <div fxFlex="15%">
          <mat-form-field appearance="standard" style="width: 100%;">
            <mat-label>Direction</mat-label>
            <mat-select [(ngModel)]="criteria.advanced.gsDirection" name="gsDirection">
              <mat-option value="Default">Default</mat-option>
              <mat-option value="Sender">Sender</mat-option>
              <mat-option value="Receiver">Receiver</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- GS ID Input -->
        <div fxFlex="0 0 auto" style="min-width: 120px;">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>GS ID</mat-label>
            <input matInput [(ngModel)]="criteria.advanced.gsId" name="gsId" aria-label="GS ID">
          </mat-form-field>
        </div>
        <div fxFlex="0 0 auto" style="width: 285px;">
          <mat-form-field appearance="fill" style="width: 100%;">
           <mat-label>Transaction Set (214, 210, 204, 211 etc.)</mat-label>
            <input matInput [(ngModel)]="criteria.advanced.tranTypCd" name="tranTypCdQuery" maxlength="3">
          </mat-form-field>
        </div>
        <div fxFlex="1 1 auto">
          <mat-form-field appearance="fill" style="width: 100%;">
            <mat-label>Segment search (e.g. AT7:1:D1, B10:1:&#123;PRONUMBER&#125;, B2:4:&#123;EDISHIPID&#125;,
              BOL:3:&#123;EDISHIPID&#125;)</mat-label>
            <input matInput [(ngModel)]="criteria.advanced.query" name="queryQuery" maxlength="30"
                   aria-label="search query"/>
          </mat-form-field>
         <!-- <md-button class="md-icon-button help-button" aria-label="Help"
                     ng-click="vm.openHelp('segmentsearch')"
                     style="position: absolute; top: 20px; right: 10px;">
            <md-icon md-icon-fontset="material-icons">help_outline</md-icon>
          </md-button>-->
        </div>

      </div>

      <!-- Time Range, Test/Prod, and Order By in one row -->
      <div fxLayout="row" fxLayoutGap="10px" style="margin-top: 2px;">
        <!-- Time Range Selector -->
        <div fxFlex="33%">
          <ng-container *ngIf="criteria.advanced.timeRange !== 'custom'">
            <mat-form-field appearance="standard" class="compact-form-field" style="width: 100%;">
              <mat-label>Time Range</mat-label>
              <mat-select [(ngModel)]="criteria.advanced.timeRange" name="timeRange" aria-label="time range filter">
                <mat-option value="" disabled="true">Limit the results to a time range</mat-option>
                <mat-option value="43200">Last 12 hours</mat-option>
                <mat-option value="86400">Last 24 hours</mat-option>
                <mat-option value="172800">Last 48 hours</mat-option>
                <mat-option value="604800">Last 7 days</mat-option>
                <mat-option value="2592000">Last 30 days</mat-option>
                <mat-option value="7776000">Last 90 days</mat-option>
                <mat-option value="15552000">Last 180 days</mat-option>
                <mat-option value="31536000">Last 365 days</mat-option>
                <mat-option value="0">Forever</mat-option>
                <mat-option value="custom">Custom date range...</mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>
        </div>

        <!-- Test/Prod -->
        <div fxFlex="33%">
          <mat-form-field appearance="standard" class="compact-form-field" style="width: 100%;">
            <mat-label>Document Region</mat-label>
            <mat-select [(ngModel)]="criteria.advanced.usageIndFilter" name="usageIndFilter">
              <mat-option value="" disabled="true">
                Filter by ISA usage indicator
              </mat-option>
              <mat-option value="any">Any</mat-option>
              <mat-option value="t" [disabled]="isInboundQuery()">Test</mat-option>
              <mat-option value="p">Production</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Order By -->
        <div fxFlex="33%">
          <mat-form-field appearance="standard" class="compact-form-field" style="width: 100%;">
            <mat-label>Order By</mat-label>
            <mat-select [(ngModel)]="criteria.advanced.orderBy" name="orderBy" id="orderBy">
              <mat-option value="" disabled>
                Sort order
              </mat-option>

              <mat-option value="isa.timestamp:desc">
                ISA timestamp (Newest to Oldest)
              </mat-option>
              <mat-option value="isa.timestamp:asc">
                ISA timestamp (Oldest to Newest)
              </mat-option>

              <mat-option *ngIf="!isWebMode" [disabled]="isInboundQuery()" value="matches.potentialCount:desc">
                Potential Match Count (Most to Least)
              </mat-option>
              <mat-option *ngIf="!isWebMode" [disabled]="isInboundQuery()" value="matches.potentialCount:asc">
                Potential Match Count (Least to Most)
              </mat-option>

              <mat-option *ngIf="!isWebMode" [disabled]="isInboundQuery()" value="matches.acceptedCount:desc">
                Accepted Match Count (Most to Least)
              </mat-option>
              <mat-option *ngIf="!isWebMode" [disabled]="isInboundQuery()" value="matches.acceptedCount:asc">
                Accepted Match Count (Least to Most)
              </mat-option>

              <mat-option *ngIf="!isWebMode" [disabled]="isInboundQuery()" value="matches.autoacceptedCount:desc">
                Auto Accepted Match Count (Most to Least)
              </mat-option>
              <mat-option *ngIf="!isWebMode" [disabled]="isInboundQuery()" value="matches.autoacceptedCount:asc">
                Auto Accepted Match Count (Least to Most)
              </mat-option>

              <mat-option value="_score">
                Match Score
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Custom Date Range -->
      <div *ngIf="criteria.advanced.timeRange === 'custom'" fxLayout="row wrap" fxLayoutGap="24px" style="margin-top: 10px;">
        <!-- Start Date -->
        <mat-form-field appearance="fill" fxFlex="45">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startPicker"
                 [(ngModel)]="criteria.advanced.startTimeRange"
                 [max]="criteria.advanced.endTimeRange"
                 name="startDate" required>
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <!-- End Date -->
        <mat-form-field appearance="fill" fxFlex="45">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endPicker"
                 [(ngModel)]="criteria.advanced.endTimeRange"
                 [min]="criteria.advanced.startTimeRange"
                 [max]="criteria.advanced.maxEndTime"
                 name="endDate" required>
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <!-- Cancel Button -->
        <button mat-icon-button
                (click)="criteria.advanced.timeRange = '86400'"
                matTooltip="Switch back to time range options">
          <mat-icon>cancel</mat-icon>
        </button>
      </div>

      <!-- Buttons -->
      <div style="text-align: right; margin-top: 10px; padding-bottom: 20px;">
        <button mat-button color="primary" type="button" (click)="clear()" aria-label="clear search criteria" title="Clear search criteria">
          <mat-icon>clear</mat-icon>
          Clear
        </button>
        <button mat-raised-button color="primary" class="xpo-primary-action" type="submit" (click)="search('advanced')" aria-label="search" title="Search">
          <mat-icon>search</mat-icon>
          Search
        </button>
      </div>

      <div class="clear-fix"></div>
      </div>
    </mat-tab>

    <!-- Reports Tab -->
    <mat-tab label="reports">
      <segment-report
        (onOpenHelp)="openHelp($event)"
        (onPost)="post($event)"
      ></segment-report>
    </mat-tab>
  </mat-tab-group>

</form>
